module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAyMCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4LjEzMDEgMTIuMDAwMUwxOS45MDAxIDEwLjIzMDFMMTAuMDAwMSAwLjMzMDA3OEwwLjEwMDE0NyAxMC4yMzAxTDEuODcwMTUgMTIuMDAwMUwxMC4wMDAxIDMuODcwMDhMMTguMTMwMSAxMi4wMDAxWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fanclub/notes/arrow.svg
// module id = 0uGE
// module chunks = 1